export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";